import React from 'react'
import MaterialSymbol from '../material-symbol'

const ThumbDownAlt = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="thumb_down_alt" {...props} />
))

ThumbDownAlt.displayName = 'ThumbDownAlt'

export default ThumbDownAlt
